import { Link } from '@reach/router';
import * as clipboard from 'clipboard-polyfill/text';
import HamburguerIcon from 'js/components-v2/common/Header/common/HamburguerIcon';
import OffcanvasAuth from 'js/components-v2/common/Header/common/OffcanvasAuth';
import PODLogo from 'js/components-v2/common/Header/common/PODLogo';
import GenerateDiscountCode from "js/components-v2/pages/UserDashboard/GenerateDiscount/GenerateDiscountCode";
import LearnMoreDiscountCode from "js/components-v2/pages/UserDashboard/LearnMore/LearnMoreDiscountCode";
import Modal from "js/components/core/Modal";
import analytics from 'js/services/Analytics';
import { makeRequest } from "js/services/Network";
import UserCountry from 'js/services/UserCountry';
import AppUser from 'js/stores/AppUser';
import UserDashboardPageState from "js/stores/pages/UserDashboardPageState";
import { pick } from "lodash";
import PubSub from 'pubsub-js';
import React from 'react';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import UserAvatar from './UserAvatar';
import { menuItems } from './Sidebar';

const Navbar = ({ currentPage }) => {
  const [stats, setStats] = React.useState({});
  const [show, setShow] = React.useState(false);
  const [showDesktop, setShowDesktop] = React.useState(false);
  const [linkCopied, setLinkCopied] = React.useState(false);
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [generateDiscount, setGGenerateDiscount] = React.useState(false);
  const [discount, setDiscount] = React.useState({});
  const [discountCopied, setDiscountCopied] = React.useState(false);

  const toggleOffCanvas = () => setShow(!show);
  const toggleOffCanvasDesktop = () => setShowDesktop(!showDesktop);
  const toggleLearnMore = () => setModalIsOpen(!modalIsOpen);
  const toggleGenerateDiscount = () => setGGenerateDiscount(!generateDiscount);
  const toggleOffModal = () => setModalIsOpen(!modalIsOpen);

  const deadline = "July, 29, 2024";
  const remInSec = Date.parse(deadline) - Date.parse(new Date());

  const [days, setDays] = React.useState(0);
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);

  const page = UserDashboardPageState.create();
  React.useEffect(async () => {
    await page.load();
    setStats(page);
  }, []);

  const leading0 = (num) => {
    return num < 10 ? "0" + num : num;
  };

  const getTimeUntil = (deadline = "July, 29, 2024") => {
    const time = Date.parse(deadline) - Date.parse(new Date());
    if (time < 0) {
      setDays(0);
      setHours(0);
      setMinutes(0);
      setSeconds(0);
    } else {
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
      setMinutes(Math.floor((time / 1000 / 60) % 60));
      setSeconds(Math.floor((time / 1000) % 60));
    }
  };

  React.useEffect(() => {
    setInterval(() => getTimeUntil(deadline), 1000);

    return () => getTimeUntil(deadline);
  }, [deadline]);

  const activeLink = (page) => {
    return `d-flex align-items-center ${currentPage === page ? 'active' : ''}`;
  };

  const copyStore = () => {
    analytics.track('Store Link Copied', {
      'Micro Seller': AppUser.login,
      'Store URL:': AppUser.store_url,
      'Country': UserCountry(),
    });

    PubSub.publish('popup-text', 'Link copied!');
    clipboard
      .writeText(AppUser.store_url)
      .then(() => {
        setLinkCopied(true);
        setTimeout(() => setLinkCopied(false), 2000);
      })
      .catch(() => {
      });
  };

  const copyCode = () => {
    analytics.track('Discount Code Copied', {
      'Micro Seller': AppUser.login,
      'Store URL:': AppUser.store_url,
      'Country': UserCountry(),
      'Discount Code': discount.code,
    });

    PubSub.publish('popup-text', 'Code copied!');
    clipboard
      .writeText(discount.code)
      .then(() => {
        setDiscountCopied(true);
        setTimeout(() => setDiscountCopied(false), 2000);
      })
      .catch(() => {
      });
  };

  const getCode = async () => {
    try {
      const response = await makeRequest('get-discount-code', null, pick(AppUser, ['login']));
      if (response.data.message === 'Discount fetched successfully') {
        setDiscount(response.data?.discount);
      } else {
        setDiscount(null)
      }
    } catch (error) {
    }
  }

  React.useEffect(() => {
    getCode().then(r => {
      // console.log(r)
    });
  }, []);

  return (
    <nav className='navbar'>
      <div className='d-flex align-items-center justify-content-between w-100'>
        <div className='navbar__name'>
          {AppUser.first_name ? `Welcome, ${AppUser.first_name}` : 'My Dashboard'}
        </div>
        <div className='navbar__logo d-flex d-lg-none'>
          <HamburguerIcon onClick={toggleOffCanvas} />
          <PODLogo />
        </div>
        <div className='navbar__controls tw-flex tw-items-center tw-justify-end'>
          <button
            className="btn-share tw-gap-2 new-pod-ui tw-flex tw-rounded-2xl tw-py-2 tw-px-4 tw-items-center"
            style={{
              border: "1px solid #6D60F6",
              background: 'transparent',
              color: '#6D60F6',
            }}
            onClick={copyStore}>
            {linkCopied ? 'Link copied!' : <>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 12' style={{
                width: '1.2rem',
                fill: '#6D60F6'
              }}>
                <path
                  d='M8.419 11.096c-.44 0-.813-.155-1.12-.463a1.531 1.531 0 0 1-.378-1.59L2.718 6.602a1.585 1.585 0 0 1-1.137.527c-.44 0-.812-.154-1.12-.461A1.525 1.525 0 0 1 0 5.548c0-.44.154-.813.461-1.12.308-.308.68-.461 1.12-.461.213 0 .416.041.61.125.195.083.37.203.527.36L6.921 2.04a.987.987 0 0 1-.062-.22 1.525 1.525 0 0 1 .44-1.357C7.606.153 7.979 0 8.419 0c.44 0 .812.154 1.12.461.307.308.461.68.461 1.12 0 .44-.154.813-.461 1.12-.308.308-.68.461-1.12.461-.216 0-.423-.034-.62-.104a1.186 1.186 0 0 1-.504-.34l-4.202 2.33a2.564 2.564 0 0 1 .07.503c0 .067-.008.136-.022.208a4.15 4.15 0 0 1-.048.219l4.202 2.385c.14-.13.3-.233.486-.312.185-.078.397-.118.638-.118.44 0 .812.154 1.12.462.307.307.461.68.461 1.12 0 .439-.154.812-.461 1.12-.308.307-.68.46-1.12.46Zm0-8.766c.213 0 .39-.072.534-.215a.726.726 0 0 0 .215-.534.724.724 0 0 0-.216-.534.726.726 0 0 0-.534-.215.724.724 0 0 0-.533.216.726.726 0 0 0-.215.534c0 .212.072.39.215.533a.726.726 0 0 0 .534.215ZM1.582 6.297c.212 0 .39-.072.533-.216a.726.726 0 0 0 .215-.534.724.724 0 0 0-.215-.533.726.726 0 0 0-.534-.215.724.724 0 0 0-.534.215.726.726 0 0 0-.215.534c0 .213.072.39.216.534a.726.726 0 0 0 .534.215Zm6.837 3.967c.213 0 .39-.072.534-.216a.726.726 0 0 0 .215-.534.724.724 0 0 0-.216-.533.726.726 0 0 0-.534-.215.724.724 0 0 0-.533.215.726.726 0 0 0-.215.534c0 .212.072.39.215.534a.726.726 0 0 0 .534.215Z' />
              </svg>
              Share store link
            </>}
          </button>
          { /* <NavSearch /> */}
          <UserAvatar onClick={toggleOffCanvasDesktop} />
        </div>
      </div>

      {stats.count_discount_users < 201 && <></>}

      <OffcanvasAuth toggle={toggleOffCanvasDesktop} show={showDesktop} />
      <Offcanvas isOpen={show} toggle={toggleOffCanvas} className='dashboard-menu'>
        <OffcanvasHeader toggle={toggleOffCanvas}>
          <PODLogo />
        </OffcanvasHeader>
        <OffcanvasBody>
          <ul className='menu-items'>
            {menuItems.map((item) => (
              <li key={item.name}>
                <Link
                  to={`${item.to}${item.to === '/seller' ? `/${AppUser.login}` : ''}`}
                  className={activeLink(item.name)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox={item.viewBox ?? "0 0 18 18"}>
                    <path d={item.icon} />
                  </svg>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </OffcanvasBody>
      </Offcanvas>
      {modalIsOpen && (
        <Modal showModal={modalIsOpen} onCancel={toggleLearnMore} withCloseButton={true}>
          <LearnMoreDiscountCode onClick={toggleOffModal} />
        </Modal>
      )}
      {generateDiscount && (
        <Modal showModal={generateDiscount} onCancel={toggleGenerateDiscount} withCloseButton={true}>
          <GenerateDiscountCode />
        </Modal>
      )}
    </nav>

  );
};

export default Navbar;
